/**
 * quiqvu: the logged-in user's Keycloak username, or undefined.
 *
 * From the OIDC user's ID-token profile, falling back to the access token's
 * claims.
 */
export default function getLoggedInUsername(userAuthenticationService): string | undefined {
  try {
    const user = userAuthenticationService?.getUser?.();
    const fromProfile = user?.profile?.preferred_username;
    if (fromProfile) {
      return fromProfile;
    }
    const payload = user?.access_token?.split('.')[1];
    if (payload) {
      const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
      return JSON.parse(json).preferred_username || undefined;
    }
  } catch {
    // no user / unreadable token
  }
  return undefined;
}
